import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_calm-authority-site/artifacts/xibj63dx_Screenshot%202024-07-25%20at%204.22.57%E2%80%AFPM.jpeg";

export const TAGLINE = "Faith in people, excellence in culture.";

/**
 * BrandMark renders the Faith 1st script logo.
 * Uses the actual JPEG on light surfaces. On dark surfaces the logo
 * sits inside a small ivory pill so the script remains legible.
 *
 * Props:
 *  - variant: "light" (dark logo on light bg) | "dark" (logo nested in light pill on dark bg)
 *  - size: "sm" | "md" | "lg" — controls height
 *  - href: when provided, wraps the mark in a Link
 *  - showTagline: when true, renders tagline below
 */
export default function BrandMark({
  variant = "light",
  size = "md",
  href,
  showTagline = false,
  taglineClass = "",
  className = "",
  testId = "brand-mark",
}) {
  const sizeMap = {
    sm: "h-10",
    md: "h-12",
    lg: "h-16",
    xl: "h-20",
  };

  const heightCls = sizeMap[size] || sizeMap.md;

  // The source JPEG has a square aspect ratio with the wordmark filling the
  // upper ~75%. We clip-path to crop out the printed tagline at the bottom so
  // we can pair the mark with a properly-typeset tagline of our own when needed.
  const cropStyle = {
    clipPath: "inset(6% 6% 22% 6%)",
    marginTop: "-6%",
    marginBottom: "-22%",
    marginLeft: "-6%",
    marginRight: "-6%",
  };

  const Img = (
    <div className={`relative inline-block ${heightCls} overflow-hidden`}>
      <img
        src={LOGO_URL}
        alt="Faith 1st"
        className={`${heightCls} w-auto block`}
        style={cropStyle}
        draggable="false"
      />
    </div>
  );

  const Wrapper = (
    <div
      data-testid={testId}
      className={`inline-flex flex-col items-start gap-1 ${className}`}
    >
      {variant === "dark" ? (
        <span className="inline-flex items-center bg-[#FDFBF7] rounded-md px-2.5 py-1">
          {Img}
        </span>
      ) : (
        Img
      )}
      {showTagline && (
        <span
          className={`font-chivo text-[9.5px] sm:text-[10px] uppercase tracking-[0.22em] ${taglineClass}`}
        >
          {TAGLINE}
        </span>
      )}
    </div>
  );

  if (href) {
    return (
      <Link to={href} className="inline-flex" aria-label="Faith 1st — home">
        {Wrapper}
      </Link>
    );
  }
  return Wrapper;
}
